export const customButtonStyles = `
  .tmce-plugin-custom-button {
    display: inline-flex;
    padding: 0 24px;
    height: 32px;
    width: fit-content;
    align-items: center;
    text-decoration: none;
    border-radius: 8px;
    font-family: 'Nunito Sans';
    sans-serif;
    font-size: 14px;
    font-weight: 900;
    box-sizing: border-box;
    vertical-align: middle;
    cursor: pointer;
  }
`;
